import Loader from "../../assets/images/spinner.gif"
const  Spinner = () => {
  return (
    <div className="spinner">
        <img src={Loader} alt="Loader"/>
    </div>
  );
}

export default Spinner;
